import { useEffect, useState } from "react";
import { GoogleLogo, Lock } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const login = () => {
  const redirectUrl = window.location.origin + "/admin";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export function ProtectedRoute({ children }) {
  const { t } = useLang();
  const [status, setStatus] = useState(null); // null=checking, true=ok, false=denied
  const denied = new URLSearchParams(window.location.search).get("error") === "denied";

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    api
      .get("/auth/me")
      .then(() => setStatus(true))
      .catch(() => setStatus(false));
  }, []);

  if (status === null) {
    return (
      <div className="flex min-h-screen items-center justify-center font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
        {t("auth.verifying")}
      </div>
    );
  }

  if (status === false) {
    const accessLines = t("auth.accessLines");
    return (
      <div
        className="flex min-h-screen items-center justify-center px-6"
        data-testid="admin-login-gate"
      >
        <div className="w-full max-w-md border border-border bg-card p-10">
          <div className="mb-8 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-primary">
            <Lock size={16} weight="bold" /> {t("auth.restricted")}
          </div>
          <h1 className="font-display font-black uppercase tracking-tighter leading-[0.85] text-4xl md:text-5xl">
            {accessLines[0]}
            <br />
            {accessLines[1]}
          </h1>
          <p className="mt-6 font-mono text-sm leading-relaxed text-muted-foreground">
            {t("auth.gateDesc")}
          </p>
          {denied && (
            <p
              className="mt-6 border border-destructive bg-destructive/10 px-4 py-3 font-mono text-xs uppercase tracking-[0.15em] text-destructive"
              data-testid="access-denied-msg"
            >
              {t("auth.denied")}
            </p>
          )}
          <button
            onClick={login}
            data-testid="google-login-btn"
            className="mt-10 flex w-full items-center justify-center gap-3 border border-foreground bg-foreground py-4 font-mono text-xs uppercase tracking-[0.25em] text-background transition-colors hover:bg-primary hover:border-primary"
          >
            <GoogleLogo size={18} weight="bold" /> {t("auth.continueGoogle")}
          </button>
        </div>
      </div>
    );
  }

  return children;
}
